import { IonGrid, IonRow, IonCol, IonButton, IonLabel, IonSlides, IonSlide, IonIonInput, IonModal, IonItem, IonContent, IonHeader, IonFooter, IonLoading, IonInput} from '@ionic/react';
import { Link, Router, Redirect, Route, Switch } from "react-router-dom";
import React, {useState, useContext, useEffect, useRef} from 'react';

import { Auth_MerchantID_context } from '../../../storeState/auth_merchantID_context';

import { TakePhoto, photos } from '../../zInternal_Features/merchant/components/TakePhoto';
import { Registration_GeoLocation} from './Registration_GeoLocation'

import '../css/zPublic.css';


export function RegisterBusinessModal (props) {

    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);

    const [acctID, setAcctID] = useState(authenticatedMerchent_context.acctID);

    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);

    let merchantFirstNameRef = useRef('');
    let merchantLastNameRef = useRef('');
    let merchantPhoneRef = useRef('');
    let merchantCompanyNameRef = useRef('');
    let merchantUsernameRef = useRef('');
    let merchantPasswordRef = useRef('');
    let [merchantBusinessType, setBusinessType] = useState('T3');
    let [selectedFile, setSelectedFile] = useState('');
    let [companyLatitude, setCompanyLatitude] = useState('');
    let [companyLongitude, setCompanyLongitude] = useState('');

    let [merchantFirstName, setMerchantFirstName] = useState('');
    let [merchantLastName, setMerchantLastName] = useState('');
    let [merchantCompanyName, setMerchantCompanyName] = useState('');
    let [merchantCity, setMerchantCity] = useState('');

    const [mobileNumber, setMobileNumber] = useState('');
    const [errorMessage, setErrorMessage] = useState('');

    let [takePhotoStatus, setTakePhotoStatus] = useState(null);
;
    let[disableRegisterButton, setDisableRegisterButton] = useState(false);

    let [isloading, setLoading] = useState(false);


    function handleFileChange(event) {


        const file = event.target.files ? event.target.files[0] : null;
        setSelectedFile(file);
    }


    function registerMerchant(e)
    {        

        e.preventDefault();

            const username = merchantUsernameRef.current.value.trim();
            const password = merchantPasswordRef.current.value.trim();

            // Check for spaces in ANY of these fields
            if (/\s/.test(username) || /\s/.test(password)) {
                alert("Spaces are not allowed in Username, or Password.");
                setDisableRegisterButton(false);
                setLoading(false);
                return; // STOP execution completely
            }

        setDisableRegisterButton(true);
        setLoading(true);

        let formData = new FormData();
        formData.append('Tracker', '72001_registration');
        formData.append('user', "register_request");
        formData.append('uMerchantFirstName', merchantFirstName.trim().replace(/[\s']/g, ''));
        formData.append('uMerchantLastName', merchantLastName.trim().replace(/[\s']/g, ''));
        formData.append('uCompanyMobileNumber', mobileNumber);
        formData.append('uCompanyName', merchantCompanyName.trim().replace(/'/g, '').replace(/\s+/g, '_'));
        formData.append('uCompanyAddressCity', merchantCity.trim().replace(/'/g, '').replace(/\s+/g, '_'));
        formData.append('uEnterBusinessType', merchantBusinessType);
        formData.append('uCompanyLatitude', companyLatitude);
        formData.append('uCompanyLongitude', companyLongitude);
        formData.append('uCreateUsername', merchantUsernameRef.current.value.trim().replace(/\s+/g, ''));
        formData.append('uCreatePassword', merchantPasswordRef.current.value.trim().replace(/\s+/g, ''));
        formData.append('sessionID', sessionID);    
        formData.append('xImageFile', selectedFile);    


        const requestOptions = {
            enctype: 'multipart/form-data',
            method:'POST',
            //credentials: 'include',
            file: formData,
            body: formData,
            contentType: false,
            processData: false,
        }
        

        fetch(baseURL+'merchants_argsApp', requestOptions)
        .then(res => res.text())
        .then(data => {

            //alert("after fetch");
            //alert(data);

            setDisableRegisterButton(false);

            let cols = data.toString().split('|');

            setLoading(false);

            if(cols[0] == "INVALID_REGISTRATION")
            {
                alert(cols[1]);
                //next();
                props.closeModal(false);
            }
            else if(props.data.source == 'job_board_register' && cols[1] == 'REGISTRATION_COMPLETED')
            {
                  //alert(cols[1]);
                //alert(merchantUsernameRef.current.value);
                //alert(merchantPasswordRef.current.value);
                props.closeModal([merchantUsernameRef.current.value, merchantPasswordRef.current.value]);
            }
            else
            {
                 alert(cols[0]);
                // alert(merchantUsernameRef.current.value);
                // alert(merchantPasswordRef.current.value);

                props.onRegistrationCompleted([merchantUsernameRef.current.value, merchantPasswordRef.current.value]);
                props.closeModal(false);

            }
        })
        .catch(error => {
            console.error(error);
        })
    }

    function retrieveCurrentGeolocation(event) 
    {
        //alert("in get current registration coordinates");
        // alert(event);
        // alert(event[0]);
        // alert(event[1]);

        setCompanyLatitude(event[0]);
        setCompanyLongitude(event[1]);
    }

    function selectedFileHandler(event)
    {

        setSelectedFile(event);

    }

    function handleSelectBusinessType(event)
    {
        setBusinessType(event[1])
    }

    function handleMobileNumberChange(e) {

        const IonInput = e.detail.value || '';
        if (!IonInput.startsWith('0')) {
            setErrorMessage('Mobile number must start with 0.');
        } else {
            setErrorMessage('');
        }
        setMobileNumber(IonInput);
    };


    function closeModalHandler() {

        if(props.data.source == 'job_board_register')
        {

            props.payCloseModal(false);
        }
        else
        {
            props.closeModal(false);
        }

    }

    useEffect(() => {

        //alert("in useefect");
        //alert(props.data.source);
        //alert(props.data.merchant_firstName);
        //alert(props.data.merchant_lastName);
        // alert(props.data.register_phoneNumber);

        if(props.data.source == 'job_board_register')
        {
            //alert("inside job_board_register");
            //alert(props.data.merchantBusinessType)

            setMerchantFirstName(props.data.merchant_firstName);
            setMerchantLastName(props.data.merchant_lastName);
            setMobileNumber(props.data.merchant_phoneNumber);
            setMerchantCompanyName(props.data.merchant_companyName);
            setMerchantCity(props.data.merchant_city);
            setBusinessType(props.data.merchant_businessType);
            const select = document.getElementById("businesstype");
            select.value = "T4"; // This sets T4 as selected

        }

    }, [])


    function isJPEG(blob) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            
            reader.onloadend = function() {
                const arr = new Uint8Array(reader.result).subarray(0, 4);
                let header = "";
                for (let i = 0; i < arr.length; i++) {
                    header += arr[i].toString(16);
    
                }
                
                // JPEG magic number: 0xFFD8
                if (header === "ffd8") {
                    resolve(true);
                } else {
                    resolve(false);
                }
            };
    
            reader.onerror = function() {
                reject(new Error("Error reading blob"));
            };
    
            reader.readAsArrayBuffer(blob.slice(0, 4));
        });
    }

    return (

            <React.Fragment>
                    <IonModal isOpen={ props.openModal }>
                      <IonHeader style={{ color: 'black' }}>
                        <IonGrid>
                            <IonRow >
                                <IonCol size='12'>
                                    <h3> COMPANY REGISTRATION </h3>
                                </IonCol>
                            </IonRow>
                        </IonGrid>
                    </IonHeader>
                    
                    <IonContent className='appPublic_gridContent'>
                            <form onSubmit={registerMerchant}>
                                <IonGrid >
                                    {acctID == null && <IonRow >
                                        <IonCol size='12' >
                                            <h5 style={{ color: 'red' }}> ACCOUNT REQUIRED. PLEASE ENTER USERNAME/PASSWORD COMPLETE PAYMENT. </h5>
                                        </IonCol>
                                    </IonRow>}
                                    <IonRow>
                                        <IonCol size='6'>
                                            <label for='searchSupplierName'>First Name:</label>
                                        </IonCol>
                                        <IonCol size='6'>
                                            <label for='searchSupplierName'>Last Name:</label>
                                        </IonCol>
                                    </IonRow>
                                    <IonRow>
                                        <IonCol size='6'>
                                            <IonInput className='professional-input' type='text' value={merchantFirstName} placeholder='Enter First Name' autocomplete='off' onIonChange={(e) => setMerchantFirstName(e.target.value)} required></IonInput>
                                        </IonCol>
                                        <IonCol size='6'>
                                            <IonInput className='professional-input' type='text' value={ merchantLastName }  placeholder='Enter Last Name' autocomplete='off' onIonChange={(e) => setMerchantLastName(e.target.value)} required></IonInput>
                                        </IonCol>
                                    </IonRow>
                                    <IonRow>
                                        <IonCol size='6'>
                                            <label for='searchSupplierName'>  Company Name:</label>
                                        </IonCol>
                                        <IonCol size='6'>
                                            <label for='searchSupplierName'>  City</label>
                                        </IonCol>
                                    </IonRow>
                                    <IonRow>
                                        <IonCol size='6'>
                                            <IonInput className='professional-input' type='text' value={ merchantCompanyName }  placeholder='Enter Company Name - 22 Letter Max' autocomplete='off' maxLength={22} onIonChange={(e) => setMerchantCompanyName(e.target.value)}  required></IonInput>
                                        </IonCol>
                                        <IonCol size='6'>
                                            <IonInput className='professional-input' type='text' value={ merchantCity }  placeholder='Enter City' autocomplete='off' maxLength={22} onIonChange={(e) => setMerchantCity(e.target.value)}  required></IonInput>
                                        </IonCol>
                                    </IonRow>
                                    <IonRow>
                                        <IonCol size='12'>
                                            <label for='searchSupplierName'>  Business Type:</label>
                                        </IonCol>
                                    </IonRow>
                                    <IonRow>
                                        <IonCol size='12'>
                                            <select name="businesstype" id='businesstype' value={merchantBusinessType} onChange={(e) => handleSelectBusinessType(['non_member', e.target.value]) }>
                                                <option value='T1'>Hotel</option>
                                                <option value='T2'>Professional Services</option>
                                                <option value='T3'  selected='selected'>Retail</option>
                                                <option value='T4'>Job Board</option>
                                            </select>
                                        </IonCol>
                                    </IonRow>
                                    <IonRow>
                                        <IonCol size="6">
                                            <label htmlFor="searchSupplierName">Mobile Number:</label>
                                        </IonCol>
                                        <IonCol size="6">
                                            <IonInput
                                                className='professional-input'
                                                id="searchSupplierName"
                                                placeholder="Enter mobile number"
                                                type="tel"
                                                value={mobileNumber}
                                                maxlength={10}
                                                onIonChange={(e) => handleMobileNumberChange(e)}
                                                required/>
                                            {errorMessage && <p style={{ color: 'red' }}>{errorMessage}</p>}
                                        </IonCol>
                                    </IonRow>
                                    <IonRow>
                                        <IonCol size='6'>
                                            <label for='searchSupplierName'>Username:</label>
                                        </IonCol>
                                        <IonCol size='6'>
                                            <label for='searchSupplierName'>Password:</label>
                                        </IonCol>
                                    </IonRow>
                                    <IonRow>
                                        <IonCol size='6'>
                                            <IonInput className='professional-input' type='text' ref={ merchantUsernameRef }  placeholder='Enter Username' autocomplete='off' required></IonInput>
                                        </IonCol>
                                        <IonCol size='6'>
                                            <IonInput className='professional-input' type='password' ref={ merchantPasswordRef }  placeholder='Enter Password' autocomplete='off' required></IonInput>
                                        </IonCol>
                                    </IonRow>
                                    {/*<IonRow>
                                        <IonCol size='12'>                            
                                            <IonButton  onClick={() => setTakePhotoStatus(true)}> Take Photo</IonButton>
                                            {takePhotoStatus == true && <TakePhoto onSelectedFile={selectedFileHandler}></TakePhoto>}
                                        </IonCol>
                                        <IonCol size='12'>
                                            <IonInput className='professional-input'
                                                type="file"
                                                accept="image/jpeg"
                                                onChange={handleFileChange}
                                            />
                                        </IonCol>
                                    </IonRow>*/}
                                    
                                </IonGrid>


                                <Registration_GeoLocation gps_location={retrieveCurrentGeolocation} ></Registration_GeoLocation>

                 
                                    {isloading == true && <IonLoading
                                        isOpen={isloading}
                                        message={'Please wait...'}
                                        duration={0} // Show until manually dismissed
                                    />}


                        <IonFooter className='grid_footer'>
                            <IonGrid>
                                <IonRow>
                                    <IonCol size='6'>
                                        <IonButton type='submit' disabled={disableRegisterButton}>Register</IonButton>
                                    </IonCol>
                                    <IonCol size='6'>
                                        <IonButton onClick={() => closeModalHandler(false)}>Cancel </IonButton>
                                    </IonCol>
                                </IonRow>
                            </IonGrid>
                        </IonFooter>
                        </form>
                    </IonContent>
                    </IonModal>
            </React.Fragment>

    )
}